/* Mural Wonder design refresh — mobile "Configure your wall" bar.
   Only shows/hides a bar and scrolls to the configurator. It does not read,
   change or submit the product form, cropper, pricing or cart. */
(function () {
  'use strict';
  function init() {
    var bar = document.querySelector('[data-mw-config-bar]');
    var target = document.querySelector('[data-mw-configure]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var link = bar.querySelector('[data-mw-config-bar-link]');
    var arrow = link ? link.querySelector('[aria-hidden]') : null;
    bar.hidden = false;
    document.body.classList.add('mw-has-config-bar');

    var visible = false;
    function update() {
      var r = target.getBoundingClientRect();
      var inView = r.top < window.innerHeight * 0.85 && r.bottom > window.innerHeight * 0.15;
      visible = !inView;
      bar.classList.toggle('is-hidden', !visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (link) link.tabIndex = visible ? 0 : -1;
      if (arrow) arrow.textContent = r.top > 0 ? '↓' : '↑';
    }
    new IntersectionObserver(update, { threshold: [0, 0.15, 0.5, 1] }).observe(target);
    window.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();

    if (link) link.addEventListener('click', function (e) {
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      // Move focus for keyboard/screen-reader users without popping the phone keyboard.
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); } }, reduce ? 0 : 450);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
